import { useEffect, useState } from 'react';
import {
  useColorScheme as _useColorScheme,
  type ColorSchemeName,
} from 'react-native';
import useAppState from '@/hooks/useAppState';

export default function useColorScheme(): NonNullable<ColorSchemeName> {
  const colorScheme = _useColorScheme() as NonNullable<ColorSchemeName>;
  const [currentScheme, setCurrentScheme] = useState(colorScheme);
  const appState = useAppState();

  useEffect(() => {
    if (appState === 'active') {
      setCurrentScheme(colorScheme);
    }
  }, [appState, colorScheme]);

  return currentScheme;
}
